(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['module', 'exports'], factory);
    } else if (typeof exports !== "undefined") {
        factory(module, exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, mod.exports);
        global.sync = mod.exports;
    }
})(this, function (module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = sync;

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var defaultOptions = {
        graceful: true
    };

    function sync(animationName) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var opts = _extends({}, defaultOptions, options);

        var elements = new Set();
        var eventTime = void 0;
        var lastInterationTS = now();
        var interationDuration = 0;

        function animationStart(event) {
            if (event.animationName === animationName) {
                var el = event.target;

                if (opts.graceful && !elements.has(el) && interationDuration !== 0) {
                    gracefulStart(el, interationDuration, lastInterationTS);
                }

                elements.add(el);
            }
        }

        function animationIteration(event) {
            if (event.animationName === animationName) {
                elements.add(event.target);

                requestAnimationFrame(function (frameTime) {
                    if (frameTime !== eventTime) {
                        interationDuration = now() - lastInterationTS;
                        lastInterationTS = now();
                        restart(elements);
                    }

                    eventTime = frameTime;
                });
            }
        }

        window.addEventListener('animationstart', animationStart, true);
        window.addEventListener('animationiteration', animationIteration, true);

        return {
            free: function free() {
                window.removeEventListener('animationstart', animationStart);
                window.removeEventListener('animationiteration', animationIteration);

                this.start();
                elements.clear();
            },
            start: function start() {
                elements.forEach(function (el) {
                    if (validate(elements, el)) {
                        el.style.removeProperty('animation');
                    }
                });
            },
            stop: function stop() {
                elements.forEach(function (el) {
                    if (validate(elements, el)) {
                        el.style.setProperty('animation', 'none');
                    }
                });
            },
            pause: function pause() {
                elements.forEach(function (el) {
                    if (validate(elements, el)) {
                        el.style.setProperty('animation-play-state', 'paused');
                    }
                });
            }
        };
    }

    function restart(elements) {
        elements.forEach(function (el) {
            if (window.getComputedStyle(el).animationPlayState !== 'paused') {
                if (validate(elements, el)) {
                    el.style.setProperty('animation', 'none');
                }
            }
        });

        requestAnimationFrame(function () {
            elements.forEach(function (el) {
                if (window.getComputedStyle(el).animationPlayState !== 'paused') {
                    if (validate(elements, el)) {
                        el.style.removeProperty('animation');
                    }
                }
            });
        });
    }

    function gracefulStart(el, interationDuration, lastInterationTS) {
        var remaining = interationDuration - (now() - lastInterationTS);
        console.log(interationDuration, remaining);
        el.style.setProperty('animation-duration', remaining);
    }

    function now() {
        return new Date().getTime();
    }

    function validate(elements, el) {
        var isValid = document.body.contains(el);
        if (!isValid) {
            elements.delete(el);
        }
        return isValid;
    }
    module.exports = exports['default'];
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-animation-sync/dist/sync.js
// module id = 299
// module chunks = 0